var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46506 19.25V12.2228C6.46506 10.1518 8.14392 8.47296 10.2149 8.47296H15.4647L13.2448 6.28304C13.1028 6.14222 13.0229 5.95053 13.0229 5.75056C13.0229 5.55059 13.1028 5.35891 13.2448 5.21809C13.5373 4.9273 14.0097 4.9273 14.3022 5.21809L17.7746 8.69045C17.8456 8.7611 17.9017 8.84525 17.9396 8.93794C18.0198 9.11946 18.0198 9.32639 17.9396 9.50792C17.8988 9.59906 17.8431 9.68272 17.7746 9.75541L14.3022 13.2503C14.0047 13.5051 13.5611 13.488 13.2841 13.2109C13.0071 12.9339 12.99 12.4904 13.2448 12.1928L15.4347 9.9729H10.1849C8.94232 9.9729 7.935 10.9802 7.935 12.2228V19.25C7.935 19.6642 7.59923 20 7.18503 20C6.77083 20 6.43506 19.6642 6.43506 19.25H6.46506Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default ForwardRef;